import { render, staticRenderFns } from "./WizardStepIndicator.vue?vue&type=template&id=63a9521e&scoped=true"
import script from "./WizardStepIndicator.vue?vue&type=script&lang=js"
export * from "./WizardStepIndicator.vue?vue&type=script&lang=js"
import style0 from "./WizardStepIndicator.vue?vue&type=style&index=0&id=63a9521e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a9521e",
  null
  
)

export default component.exports